const initialState = {
  facts: null,
  guestRsvpSelectedEventId: null,
  isFetching: false,
  rsvpSummary: null,
  upgradePrice: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "DASHBOARD_SET_IS_FETCHING":
      return {
        ...state,
        isFetching: action.payload,
      };
    case "DASHBOARD_UPGRADE_PRICE_FETCHED":
      return {
        ...state,
        upgradePrice: action.payload,
      };
    case "DASHBOARD_SET_GUEST_RSVP_SELECTED_EVENT_ID":
      return {
        ...state,
        guestRsvpSelectedEventId: action.payload,
      };
    default:
      return state;
  }
};
